import React from "react";
import { Category } from "../../../../application/domain/help/help-entity";

export type NavigatorProps = {
  categoryList: Category[];
  productId: string;
};

export type NavigatorContentProps = {
  category: Category;
  productId: string;
};

export const useNavigatorController = ({
  categoryList,
  productId,
}: NavigatorProps) => {
  const filteredCategoryList = React.useMemo(() => {
    return categoryList.map((category) => {
      return {
        ...category,
        metadata: {
          ...category.metadata,
          children: category.metadata.children.filter(
            (child) => child.metadata.product.id === productId,
          ),
        },
      };
    });
  }, [categoryList, productId]);

  return {
    filteredCategoryList,
  };
};
